import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class CardHandler implements OnInit {
  @Input() cardData;
  @Input() includeKeys = ['resultValue', 'result', 'startDt', 'endDt', 'endDt'];

  constructor(public router: Router, public settingService: SettingService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cardData && this.cardData) {
      this.cardData = this.cardData.map((data) => ({
        ...data,
        randomColor: this.generateReadableColor(),
      }));
    }
  }

  isNumeric(value: any): boolean {
    return value !== null && value !== '' && !isNaN(+value);
  }

  generateReadableColor(): string {
    const min = 60;
    const max = 200;
    const r = Math.floor(Math.random() * (max - min) + min);
    const g = Math.floor(Math.random() * (max - min) + min);
    const b = Math.floor(Math.random() * (max - min) + min);
    return `rgb(${r}, ${g}, ${b})`;
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj).filter(
      (key) => key != 'randomColor' && key != 'link' && this.includeKeys.includes(key)
    );
  }

  formatKey(key: string) {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/_/g, ' ')
      .replace(/^./, (char) => char.toUpperCase());
  }

  openDetail(link: any) {
    this.router.navigate([link]);
  }
}
